<!-- Not Generated Yet Template -->

@if (slideAuthorFacade.currentSelectedSlide$ | async; as page) {
  <!-- Header -->
  @if (page) {
    <medsurf-slide-edit-header
      [icon]="FlatModels.PageEntityModels.PageTypeAndDepthIcon(page.type, 0)"
      [label]="page.title"
    [type]="'enum.pageType.' + page.type"></medsurf-slide-edit-header>
  }
  <!-- Content -->
  <div #edit_overlay_template_scroll_panel
    class="flex flex-1 overflow-auto justify-content-center">
    <!-- Accordion -->
    <p-accordion [activeIndex]="[0, 1, 2, 3, 4]"
      [multiple]="true"
      styleClass="no_border"
      class="w-full h-full ml-3 mr-3">
      <p-accordionTab [header]="'global.general' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-1 flex-column row-gap-2 align-items-center">
          <!-- Page Form -->
          @if (pageForm) {
            <medsurf-design-form-control-form
              [formGroup]="pageForm"
              [class]="'w-full'"
              (onSubmit)="onSubmit()">
              <div class="flex flex-1 flex-column row-gap-2 align-items-center">
                <!-- Title -->
                <medsurf-design-form-control-input-text [control]="pageForm.controls.title"
                  [label]="'global.title'"
                  [class]="'w-full'"
                (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                <!-- Description -->
                <medsurf-editor [control]="pageForm.controls.description"
                  [label]="'global.description'"
                  [placeholder]="'global.description'"
                  [class]="'h-full'"
                  [fullHeight]="true"
                  [autogrow]="false"
                (valueChange)="onSubmit()"></medsurf-editor>
                <!-- Modality -->
                @if (slideAuthorFacade.modalityArray$ | async; as modalityArray) {
                  @if (modalityArray && modalityArray.length > 0) {
                    <medsurf-design-form-control-input-dropdown
                      [control]="pageForm.controls.modality"
                      [label]="'global.modality'"
                      [placeholder]="'global.choose'"
                      [class]="'w-full'"
                      [options]="modalityArray"
                      [filter]="true"
                      [showClear]="true"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
                  }
                }
                <h4 class="uppercase align-self-start my-2"
                  translate="global.editing">
                </h4>
                <!-- Status -->
                <medsurf-design-form-control-input-dropdown [control]="pageForm.controls.status"
                  [label]="'global.status'"
                  [options]="FlatModels.SlideAuthorModels.SlideStateLists"
                  [class]="'w-full'"
                (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
                <!-- Comment -->
                <medsurf-editor class="w-full"
                  label="global.comment"
                  placeholder="global.comment"
                  [control]="pageForm.controls.authorNote"
                  [toolbarExcludes]="['mediaimage', 'mediapdf', 'mediaaudio', 'mediavideo', 'marker']"
                (valueChange)="onSubmit()"></medsurf-editor>
              </div>
            </medsurf-design-form-control-form>
          }
          <h4 class="uppercase align-self-start my-2"
            translate="global.metadata">
          </h4>
          <!-- Ids -->
          <div
            class="flex flex-1 flex-column align-self-start cursor-pointer" (click)="clipboardAuthorFacade.requestCopyToClipboard(page.id)">
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ 'ID' }}:
            </span>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ page.id }}
            </span>
          </div>
          <div
            class="flex flex-1 flex-column align-self-start cursor-pointer" (click)="clipboardAuthorFacade.requestCopyToClipboard(node?.id)">
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ 'global.node_id' | translate }}:
            </span>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ node?.id }}
            </span>
          </div>
          <div
            class="flex flex-1 flex-column align-self-start cursor-pointer" (click)="clipboardAuthorFacade.requestCopyToClipboard(page.slideId)">
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ 'global.slide_id' | translate }}:
            </span>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ page.slideId }}
            </span>
          </div>
          <!-- Edited At -->
          <div
            class="flex flex-1 flex-column align-self-start">
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ 'global.edited_at' | translate }}:
            </span>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ page.editedAt | date_shared }}
            </span>
          </div>
          <!-- Created At -->
          <div class="flex flex-1 flex-column align-self-start">
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ 'global.created_at' | translate }}:
            </span>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
              {{ page.createdAt | date_shared }}
            </span>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab [header]="'global.layout' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-column row-gap-2 align-items-center">
          <!-- Page Form -->
          @if (pageForm) {
            <medsurf-design-form-control-form
              [formGroup]="pageForm"
              [class]="'w-full'"
              (onSubmit)="onSubmit()">
              <!-- Sidebar Ratio -->
              <medsurf-design-form-control-input-dropdown [control]="pageForm.controls.sideBarSize"
                [label]="'global.sidebar_ratio'"
                [options]="FlatModels.SlideAuthorModels.SidebarRatioLists"
                [class]="'w-full'"
                [placeholder]="'global.choose'"
              (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
            </medsurf-design-form-control-form>
          }
          <!-- Image Form -->
          @if (layoutForm) {
            <medsurf-design-form-control-form
              [formGroup]="layoutForm"
              [class]="'w-full'"
              (onSubmit)="onLayoutSubmit()">
              <!-- Background Color -->
              <medsurf-design-form-control-input-color-picker [control]="layoutForm.controls.color"
                [label]="'global.background_color'"
                [class]="'w-full'"
              (valueChange)="onLayoutSubmit()"></medsurf-design-form-control-input-color-picker>
            </medsurf-design-form-control-form>
          }
        </div>
      </p-accordionTab>
      <p-accordionTab [header]="'global.viewer' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-1 flex-column align-items-center">
          <!-- Page Form -->
          @if (pageForm) {
            <medsurf-design-form-control-form
              [formGroup]="pageForm"
              [class]="'w-full'"
              (onSubmit)="onSubmit()">
              <!-- Thumbnail -->
              <medsurf-media-library-modal [mediaId]="pageForm.value.thumbnailMedia"
                                           [label]="'global.thumbnail'"
                                           [allowedTypes]="[
                                             FlatModels.MediaEntityModels.MediaType.enum.MediaImage,
                                             FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom,
                                             FlatModels.MediaEntityModels.MediaType.enum.MediaVideo
                                           ]"
                                           (mediaChange)="onMediaChange($event)"
                                           [class]="'w-full align-self-start'"></medsurf-media-library-modal>
            </medsurf-design-form-control-form>
          }
          @if (nodeForm || nodeSettingsForm) {
            <div class="flex flex-1 align-self-start">
              <h5 class="uppercase mt-1">
                {{ 'global.visibility' | translate }}
              </h5>
            </div>
          }
          @if (nodeForm) {
            <medsurf-design-form-control-form
              [formGroup]="nodeForm"
              [class]="'w-full'"
              (onSubmit)="onNodeSubmit()">
              <!-- Hidden -->
              <medsurf-design-form-control-input-checkbox [control]="nodeForm.controls.hidden"
                [label]="'global.hide_slide_in_viewer'"
                [class]="'w-full'"
              (valueChange)="onNodeSubmit()"></medsurf-design-form-control-input-checkbox>
            </medsurf-design-form-control-form>
          }
          <!-- Node Settings Form -->
          @if (nodeSettingsForm) {
            <medsurf-design-form-control-form
              [formGroup]="nodeSettingsForm"
              [class]="'w-full'"
              (onSubmit)="onNodeSettingsSubmit()">
              <!-- Show Annotations -->
              <medsurf-design-form-control-input-checkbox [control]="nodeSettingsForm.controls.hideAnnotations"
                [label]="'global.hide_annotations'"
                [class]="'w-full'"
              (valueChange)="onNodeSettingsSubmit()"></medsurf-design-form-control-input-checkbox>
            </medsurf-design-form-control-form>
          }
        </div>
      </p-accordionTab>
      <p-accordionTab [header]="'global.preferences' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-1 flex-column align-items-center">
          <div class="flex flex-1 align-self-start">
            <h5 class="uppercase mt-1">
              <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"></i>
              {{ 'global.annotations' | translate }}
            </h5>
          </div>
          <!-- Preferences Form -->
          @if (preferencesForm) {
            <medsurf-design-form-control-form
              [formGroup]="preferencesForm"
              [class]="'w-full'"
              (onSubmit)="onSubmit()">
              <!-- Label Color -->
              <medsurf-design-form-control-input-color-picker [control]="preferencesForm.controls.labelColor"
                [label]="'global.font_color'"
                [class]="'w-full'"
              (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
              <!-- Pointer Color -->
              <medsurf-design-form-control-input-color-picker [control]="preferencesForm.controls.pointerColor"
                [label]="'global.point_color'"
                [class]="'w-full'"
              (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
              <!-- Font Size -->
              <medsurf-design-form-control-input-dropdown [control]="preferencesForm.controls.labelFontSize"
                [label]="'global.font_size'"
                [options]="FlatModels.KeymapStyleEntityModels.FontSizeArray"
                [class]="'w-full'"
              (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
            </medsurf-design-form-control-form>
          }
        </div>
      </p-accordionTab>
      <p-accordionTab [header]="'global.path_and_export' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-column align-items-start">
          <!-- Route -->
          <medsurf-common-route class="w-full"></medsurf-common-route>
          <!-- Download -->
          <div class="flex flex-1 flex-column row-gap-2 w-full mt-3 mb-4">
            <label id="generate_pdf_label"
                    class="mb-2"
                    for="pdf_menu">
              {{ 'global.slide_pdf' | translate }}
            </label>
            <div class="flex align-items-center gap-2">
              @if (isGenerating()) {
                  <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
              } @else {
                @if ({
                  blocked: (historySharedFacade.canSave$ | async) || false
                }; as pdfGeneration) {
                  <medsurf-design-input-menu [formField]="false"
                    [name]="'pdf_menu'"
                    [label]="'global.pdf_generate'"
                    [blockUi]="[ {blocked: pdfGeneration.blocked, iconClass: 'warning'} ]"
                    [items]="pdfMenuItems"></medsurf-design-input-menu>
      
                  @if (historySharedFacade.canSave$ | async) {
                    <small>{{ 'global.save_all_changes_before_generating' | translate }}</small>
                  }
                }
              } 
            </div>
            <div class="flex flex-wrap gap-2">
              @if ( nodeSharedFacade.currentSelectedPageViewerPdf$ | async; as viewerPdf) {
                <button medsurf-design-input-button
                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PDF_DOWNLOAD"
                  (click)="downloadPdf(viewerPdf, 'viewer')">
                  <span [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PDF"></span>
                  <div>
                    <small>{{ viewerPdf.editedAt | date_shared }}</small><br>
                    <strong>Viewer | {{ viewerPdf.name }}</strong>
                  </div>
                </button>
              }
              @if (nodeSharedFacade.currentSelectedPageAuthorPdf$ | async; as authorPdf) {
                <button medsurf-design-input-button
                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PDF_DOWNLOAD"
                  (click)="downloadPdf(authorPdf, 'author')">
                  <span [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PDF"></span>
                  <div>
                    <small>{{ authorPdf.editedAt | date_shared }}</small><br>
                    <strong>Author | {{ authorPdf.name }}</strong>
                  </div>
                </button>
              }
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
}
